// Hộp lỗi dùng chung cho lỗi range / nối tập / localize (E3-P1, Y4). Văn bản do `describeAdaptationError` dựng.
import React from 'react';
import { Button, Modal, Space, Typography } from 'antd';
import type { AdaptationErrorView } from './adaptationUtils';
import { EXIT_LABEL } from './workbench/overview/overviewErrors';

const { Text } = Typography;

interface Props {
  error: AdaptationErrorView | null;
  onClose: () => void;
  /** Có ⇒ hiện nút phục hồi. Nhãn + mô tả do nơi gọi dựng (nó biết số tập sẽ viết lại). */
  recover?: { label: string; description: string; onClick: () => void; disabled?: boolean } | null;
  busy?: boolean;
  /** 261015 P4c-2c-1 (D10) — lỗi có `exit:'openOverview'` (OVERVIEW_NOT_EFFECTIVE / OVERVIEW_CHANGED) ⇒ nút "Mở Tổng quan truyện"; nơi gọi đóng hộp rồi điều hướng tới ② tab Tổng quan truyện. */
  onOpenOverview?: () => void;
}

const AdaptationErrorModal: React.FC<Props> = ({ error, onClose, recover, busy, onOpenOverview }) => (
  <Modal
    open={!!error} title={error?.title} onCancel={onClose} width={620}
    footer={(
      <Space>
        <Button onClick={onClose}>Đóng</Button>
        {error?.exit === 'openOverview' && onOpenOverview && (
          <Button type="primary" onClick={onOpenOverview}>{EXIT_LABEL.openOverview}</Button>
        )}
        {recover && (
          <Button type="primary" danger loading={busy} disabled={recover.disabled} onClick={recover.onClick}>
            {recover.label}
          </Button>
        )}
      </Space>
    )}
  >
    <Space direction="vertical" size={6} style={{ width: '100%' }}>
      {error?.lines.map((l, i) => <Text key={i} style={{ fontSize: 13 }}>{l}</Text>)}
      {recover && <Text type="secondary" style={{ fontSize: 13 }}>{recover.description}</Text>}
      <Text type="secondary" style={{ fontSize: 11 }}>
        Chỉ để định hướng — cổng thật nằm ở máy chủ, nên có thể còn lý do khác sau khi viết lại.
      </Text>
    </Space>
  </Modal>
);

export default AdaptationErrorModal;
